import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RegisterComponent } from './register/register.component';
import { SurveyUrlComponent } from './survey-url/survey-url.component';

import { AuthGuard } from './auth/auth.guard';
import { RouteRedirectGuard } from './auth/route-redirect.guard';

import { HomeComponent } from './home/home.component';
import { ExceptionComponent } from './shared/components/error/exception.component';
import { ComingSoonComponent } from './shared/components/coming-soon/comingsoon.component';

import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

import { EntitySearchComponent } from './entity-search/entity-search.component';
import { BusinessProcessComponent } from './business-process/business-process.component';

import { AppComponent } from './app.component';
import { IncidentComponent } from './incident/incident.component';

import { UserManagementComponent } from './user-management/user-management.component';
import { ManageGroupUsersComponent } from './manage-group-users/manage-group-users.component';
import { SupervisorMappingComponent } from './supervisor-mapping/supervisor-mapping.component';
import { ConfirmPasswordComponent } from './confirm-password/confirm-password.component';

import { SSOLoginComponent } from './sso-login/sso-login.component';
import { MapUserGroupComponent } from './map-user-group/map-user-group.component';

import { DashboardReportsComponent } from './dashboard-reports/dashboard-reports.component';
import { LandingPageComponent } from './landingpage/landingpagecomponent';
import { DemoLandingComponent } from './demo-landing-page/demo-landing.component';
import { RsLandingComponent } from './rs-landing/rs-landing.component';

import { HelpComponent } from './shared/components/help/helpcomponent';
import { ContactComponent } from './shared/components/contact/contactcomponent';
import { RsHelpComponent } from './shared/components/rs-help/rs-help.component';
import { RSContactComponent } from './shared/components/rs-contact/rs-contact.component';

import { ResourceUploadComponent } from './resource-upload/resource-upload.component';

import { SiteminderLoginComponent } from './siteminder-login/siteminder-login.component';

const routes: Routes = [
  {
    path: 'user',
    loadChildren: () =>
      import('./user/user.module').then((m) => m.UserModule),
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'create',
    loadChildren: () =>
      import('./create/create.module').then((m) => m.CreateModule),
    canActivate: [AuthGuard],
  },

  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },

  {
    path: 'register',
    component: RegisterComponent,
  },
  {
    path: 'supervisor-mapping',
    component: SupervisorMappingComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'login',
    component: SiteminderLoginComponent,
  },
  {
    path: 'sso',
    component: SSOLoginComponent,
  },

  {
    path: 'main',
    component: HomeComponent,
  },
  {
    path: 'home',
    component: HomeComponent,
  },

  {
    path: 'survey/:id',
    component: SurveyUrlComponent,
  },
  {
    path: 'survey/:id/:groupId',
    component: SurveyUrlComponent,
  },

  {
    path: 'forgotpassword',
    component: ForgotPasswordComponent,
  },
  {
    path: 'resetpassword',
    component: ResetPasswordComponent,
    pathMatch: 'prefix',
  },
  {
    path: 'confirmPassword',
    component: ConfirmPasswordComponent,
  },

  {
    path: 'mapuser',
    component: MapUserGroupComponent,
  },

  {
    path: 'odp/signin-oidc-bp',
    component: SiteminderLoginComponent,
  },

  {
    path: 'search',
    component: EntitySearchComponent,
  },
  {
    path: 'businessProcess',
    component: BusinessProcessComponent,
  },
  {
    path: 'incidentReport',
    component: IncidentComponent,
  },

  {
    path: 'userManagement',
    component: UserManagementComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'managegroupUser',
    component: ManageGroupUsersComponent,
  },

  {
    path: 'logout',
    component: AppComponent,
  },
  {
    path: 'reports',
    component: DashboardReportsComponent,
  },

  {
    path: 'homePage',
    canActivate: [RouteRedirectGuard],
    data: { routeType: 'home' },
    children: [],
  },
  {
    path: 'scoHomePage',
    component: LandingPageComponent,
  },
  {
    path: 'demoHomePage',
    component: DemoLandingComponent,
  },
  {
    path: 'rsHomePage',
    component: RsLandingComponent,
  },

  {
    path: 'help',
    canActivate: [RouteRedirectGuard],
    data: { routeType: 'help' },
    children: [],
  },
  {
    path: 'help-content',
    component: HelpComponent,
  },
  {
    path: 'rs-help',
    component: RsHelpComponent,
  },

  {
    path: 'contact',
    canActivate: [RouteRedirectGuard],
    data: { routeType: 'contact' },
    children: [],
  },
  {
    path: 'sco-contact',
    component: ContactComponent,
  },
  {
    path: 'rs-contact',
    component: RSContactComponent,
  },

  {
    path: 'resource-upload',
    component: ResourceUploadComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'coming-soon',
    component: ComingSoonComponent,
  },

  {
    path: 'unauthorized',
    redirectTo:
      '/exception?code=403&message=Unauthorized Access&helpText=You do not have permission to view this page.',
  },

  {
    path: '**',
    component: ExceptionComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}